export class ExternalProgramMappingsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  #buildQueryString({ page, pageSize, search, sortBy, isDescending }) {
    const params = new URLSearchParams();

    if (page != null) {
      params.append('page', page);
    }

    if (pageSize != null) {
      params.append('pageSize', pageSize);
    }

    if (search) {
      params.append('search', search);
    }

    if (sortBy) {
      params.append('sortBy', sortBy);
    }

    if (isDescending != null) {
      params.append('isDescending', isDescending);
    }

    const query = params.toString();

    return query ? `?${query}` : '';
  }

  async getMappings({ pricingEngineType, page, pageSize, search }) {
    const queryString = this.#buildQueryString({ page, pageSize, search });

    return this.#http.get(`/api/external-program-mappings/${pricingEngineType}${queryString}`);
  }

  async getPagedMappings({ pricingEngineType, page, pageSize, search, sortBy, isDescending }) {
    const queryString = this.#buildQueryString({ page, pageSize, search, sortBy, isDescending });

    return this.#http.get(
      `/api/external-program-mappings/${pricingEngineType}/paged${queryString}`,
    );
  }

  async getGroupedMappings({ pricingEngineType, page, pageSize, search }) {
    const queryString = this.#buildQueryString({ page, pageSize, search });

    return this.#http.get(
      `/api/external-program-mappings/${pricingEngineType}/grouped${queryString}`,
    );
  }

  async createMapping({ pricingEngineType, ...body }) {
    return this.#http.post(`/api/external-program-mappings/${pricingEngineType}`, body);
  }

  async updateMapping({ pricingEngineType, id, ...body }) {
    return this.#http.put(`/api/external-program-mappings/${pricingEngineType}/${id}`, body);
  }

  async deleteMapping({ pricingEngineType, id }) {
    return this.#http.delete(`/api/external-program-mappings/${pricingEngineType}/${id}`);
  }

  async batchUpdate({ pricingEngineType, create = [], update = [], delete: deleteIds = [] }) {
    return this.#http.post(`/api/external-program-mappings/${pricingEngineType}/batch`, {
      create,
      update,
      delete: deleteIds,
    });
  }

  async getObProducts({ pricingEngineType, page, pageSize, search }) {
    const queryString = this.#buildQueryString({ page, pageSize, search });

    return this.#http.get(
      `/api/external-program-mappings/${pricingEngineType}/external-programs${queryString}`,
    );
  }

  async getGroupedObProducts({ pricingEngineType, page, pageSize, search }) {
    const queryString = this.#buildQueryString({ page, pageSize, search });

    return this.#http.get(
      `/api/external-program-mappings/${pricingEngineType}/external-programs/grouped${queryString}`,
    );
  }

  async refreshObProducts({ pricingEngineType }) {
    return this.#http.post(
      `/api/external-program-mappings/${pricingEngineType}/external-programs/refresh`,
    );
  }
}
